const getUpgradeBannerTranslations = content => {
  const bannerTranslations = {
    bannerTitle: undefined,
    bannerSubtitle: undefined
  };
  if (content && content.length > 0) {
    content.forEach(contentObj => {
      const {
        contentType,
        text
      } = contentObj;
      if (contentType === 'HEADING_SHORT') {
        bannerTranslations.bannerTitle = text;
      } else if (contentType === 'BODY_SHORT') {
        bannerTranslations.bannerSubtitle = text;
      }
    });
  }
  return bannerTranslations;
};
export default getUpgradeBannerTranslations;